// FAMILY-EXT: API-клиент для внешних хранилищ (управление + доступные
// для доски).

import http from './http';
import socket from './socket';

const browseStorages = (headers) => http.get('/external-storages', undefined, headers);

const createStorage = (data, headers) =>
  socket.post('/external-storages', data, headers);

const updateStorage = (id, data, headers) =>
  socket.patch(`/external-storages/${id}`, data, headers);

const deleteStorage = (id, headers) =>
  socket.delete(`/external-storages/${id}`, undefined, headers);

const browseStoragesForBoard = (boardId, headers) =>
  http.get(`/boards/${boardId}/external-storages`, undefined, headers);

export default {
  browseStorages,
  createStorage,
  updateStorage,
  deleteStorage,
  browseStoragesForBoard,
};
